import carousel from '@/js/util/symbols/carousel'

export default {
  inject: { carousel },

  mounted() {
    this.emitEvent('create:buttons', this)
  },

  methods: {
    handleButtonClick() {
      // for this component to work you have to bind the index to the
      // component's key property. :key="index"
      this.carousel.$emit('set:item', this.carousel.items[this.$vnode.key - 1])
    },
    handleKeyPress(event) {
      // accessibility control
      if (event.shiftKey && event.keyCode === 9 && this.$vnode.key != 1) {
        // console.log(this.$vnode.key)
        this.carousel.$emit(
          'set:item',
          this.carousel.items[this.$vnode.key - 1]
        )
      } else if (
        event.code === 'Tab' &&
        this.$vnode.key != this.carousel.items.length &&
        !this.carousel.isHero
      ) {
        this.carousel.$emit(
          'set:item',
          this.carousel.items[this.$vnode.key - 1]
        )
      }
    },
    emitEvent(...events) {
      this.carousel.$emit(...events)
    },
  },

  render(createElement) {
    const elementData = {
      on: {
        click: this.handleButtonClick,
        keydown: this.handleKeyPress,
      },
    }
    return createElement('button', elementData, this.$slots.default)
  },
}
